import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  loader = false
  constructor(private http : HttpClient) { }

  showLoader(){
    this.loader = true
  }

  hideLoader(){
    this.loader = false
  }

  getAllSources(){
    return this.http.get(`${environment.apiUrl}/source-currencies`)
  }

  getAllDestinations(){
    return this.http.get(`${environment.apiUrl}/destination-currencies/`)
  }

  getFees(source, destination){
    return this.http.get(`${environment.apiUrl}/fees?source_currency.name=${source}&destination_currency.name=${destination}`)
  }

  getExchangeRate(source,destination){
    return this.http.get(`${environment.apiUrl}/conversions?source=${source}&destination=${destination}`)
  }
}
